import React from 'react'
import ApiDoc from '../../apidoc'
import api from '../../../../../../api-server/dist/openapi/v0/dataprocessing.json';

export default props => <ApiDoc spec={api} {...props} />
